import { Box, Card, CardContent, Skeleton, Stack, Divider } from '@mui/material';
import { Container } from '../../../components/container';

export const NotificationsSkeleton = () => (
  <Container>
    <Box sx={{ mb: 4, display: 'flex', alignItems: 'center' }}>
      <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
      <Skeleton variant="text" width={180} height={40} />
    </Box>

    <Box sx={{ mb: 3, display: 'flex', gap: 1, alignItems: 'center' }}>
      <Skeleton variant="text" width={60} height={20} sx={{ mr: 2 }} />
      <Skeleton variant="rounded" width={80} height={32} />
      <Skeleton variant="rounded" width={90} height={32} />
      <Skeleton variant="rounded" width={70} height={32} />
      <Box sx={{ flex: 1 }} />
      <Skeleton variant="rounded" width={120} height={36} />
    </Box>

    <Stack spacing={2}>
      {[1, 2, 3, 4, 5].map((index) => (
        <Card key={index} sx={{ position: 'relative' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <Skeleton variant="rounded" width={60} height={20} />
                </Box>
                <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="70%" height={20} />
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  gap: 1,
                }}
              >
                <Skeleton variant="text" width={80} height={16} />
                <Skeleton variant="circular" width={8} height={8} />
              </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Notification Actions */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width={80} height={16} />
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="rounded" width={80} height={32} />
                <Skeleton variant="rounded" width={60} height={32} />
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Stack>

    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Skeleton variant="rounded" width={120} height={40} />
    </Box>
  </Container>
);
